import { Component, Input, OnInit } from '@angular/core';
import { SummaryStatus } from '@shared/models/summary-status';
import Utils from '@shared/utils/utils';
import { Company } from '@shared/enums/company';
import { AuthService } from '@core/auth/auth.service';

@Component({
  selector: 'app-status-view',
  templateUrl: './status-view.component.html',
  styleUrls: ['./status-view.component.scss']
})
export class StatusViewComponent implements OnInit {

  @Input() tabName: any;
  @Input() summaryStatusData: SummaryStatus[];


  company;
  companies = Company;

  constructor(private authService: AuthService) {
    this.company = this.authService.getCurrentCompany();
  }


  @Input()
  set setSummaryStatusData(value) {
    if (!Utils.isEmpty(value)) {
      this.summaryStatusData = value;
    } else {
      this.summaryStatusData = [];
    }
  }

  ngOnInit(): void {
  }
}
